/**
 * @fileoverview GET handler for the "/custom_objects/:type_name/:external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalId } from "./constants";
import type { GetCustomObjectsTypeNameExternalIdResult } from "./types";
import { isGetCustomObjectsTypeNameExternalIdResult } from "./validators";

export const getCustomObjectsTypeNameExternalId = reactQueryFetcherAdapter(
  customObjectsTypeNameExternalId,
  (
    signal: AbortSignal,
    typeName: string,
    externalId: string
  ): Promise<GetCustomObjectsTypeNameExternalIdResult> => {
    return fetch(
      `/custom_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsTypeNameExternalIdResult
);
